<template>
  <a-modal
      v-model:visible="visible"
      :title="isEditMode ? '修改项目工单' : '新增项目工单'"
      :on-before-ok="handleOk"
      @cancel="handleCancel"
      width="1400px"
      :mask-closable="false"
      :ok-loading="loading"
      draggable
  >
    <a-form ref="formRef" :model="formData" :rules="rules" layout="vertical">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="项目服务单ID" field="projectServiceOrderId">
            <a-select
              v-model="formData.projectServiceOrderId"
              :options="projectServiceOrderOptions"
              @change="handleProjectServiceOrderChange"
              placeholder="请选择项目服务单"
              allow-clear
              :allow-search="{ retainInputValue: false }"
              :virtual-list-props="{ height: 300 }"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="所属门店" field="storeId">
            <a-select
                v-model="formData.storeId"
                :options="customerStoreOptions"
                placeholder="请选择所属门店"
                allow-clear
                :allow-search="{ retainInputValue: false }"
                :virtual-list-props="{ height: 300 }"
                disabled
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="工单编码" field="workorderCode">
            <a-input v-model="formData.workorderCode" placeholder="请输入工单编码" allow-clear/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="工单类型" field="workorderType">
            <a-select
              v-model="formData.workorderType"
              :options="workOrderTypeOptions"
              placeholder="请选择工单类型"
              allow-clear
              :allow-search="{ retainInputValue: false }"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="工作类别" field="workCategory">
            <a-select
              v-model="formData.workCategory"
              :options="workCategoryOptions"
              placeholder="请选择工作类别"
              allow-clear
              :allow-search="{ retainInputValue: false }"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="是否紧急" field="urgent">
            <a-switch v-model="formData.urgent" />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 将计划时间段、服务人员、工单状态放在同一行 -->
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="计划时间段" field="serviceTime">
            <a-date-picker
              v-model="formData.serviceTime"
              placeholder="请选择计划时间段"
              allow-clear
              format="YYYY-MM-DD"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="服务人员" field="servicePersonIds">
            <a-select
              v-model="formData.servicePersonIds"
              :options="userOptions"
              placeholder="请选择服务人员"
              allow-clear
              multiple
              :max-tag-count="3"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="工单状态" field="workStatus">
            <a-select
              v-model="formData.workStatus"
              :options="workOrderStatusOptions"
              placeholder="请选择工单状态"
              allow-clear
              :allow-search="{ retainInputValue: false }"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 添加开始时间和结束时间 -->
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="开始时间" field="startTime">
            <a-date-picker
              v-model="formData.startTime"
              placeholder="请选择开始时间"
              allow-clear
              format="YYYY-MM-DD HH:mm:ss"
              show-time
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="结束时间" field="endTime">
            <a-date-picker
              v-model="formData.endTime"
              placeholder="请选择结束时间"
              allow-clear
              format="YYYY-MM-DD HH:mm:ss"
              show-time
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="工作内容" field="workContent">
        <a-textarea
          v-model="formData.workContent"
          placeholder="请输入工作内容"
          :rows="3"
          allow-clear
        />
      </a-form-item>

      <a-form-item label="工作地点" field="workLocation">
        <a-textarea
          v-model="formData.workLocation"
          placeholder="请输入工作地点"
          :rows="2"
          allow-clear
        />
      </a-form-item>

      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="联系人" field="contactPerson">
            <a-input v-model="formData.contactPerson" placeholder="请输入联系人" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="联系电话" field="contactPhone">
            <a-input v-model="formData.contactPhone" placeholder="请输入联系电话" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="预计工时(分钟)" field="estimatedDuration">
            <a-input-number
              v-model="formData.estimatedDuration"
              placeholder="请输入预计工时"
              :min="0"
              :precision="0"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="实际工时(分钟)" field="actualDuration">
            <a-input-number
              v-model="formData.actualDuration"
              placeholder="请输入实际工时"
              :min="0"
              :precision="0"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="备注" field="remark">
        <a-textarea
          v-model="formData.remark"
          placeholder="请输入备注"
          :rows="3"
          allow-clear
        />
      </a-form-item>

      <!-- 子表编辑按钮 -->
      <a-form-item v-if="isEditMode" label="子表信息">
        <a-button type="primary" @click="openSubTableEdit">
          <icon-edit /> 编辑其他信息
        </a-button>
      </a-form-item>
    </a-form>
  </a-modal>

  <!-- 子表编辑模态框 -->
  <SubTableEdit
    v-model="subTableEditVisible"
    :work-order-id="formData.id"
    @success="handleSubTableSuccess"
  />
</template>

<script setup>
import { ref, watch, nextTick, computed, onMounted } from 'vue'
import { Message } from '@arco-design/web-vue'
import {
  addWorkOrder,
  updateWorkOrder,
  getWorkOrder
} from '@/apis/work-order-api'
import {useCustomerStoreInfoStore} from "@/store/customer-data"
import {useSysDictDataStore} from "@/store/system-data"
import {useProjectServiceOrderStore} from "@/store/work-order-data"
import {useUserDataStore} from "@/store/user-data"
import SubTableEdit from './SubTableEdit.vue'

// 定义 props
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  workOrderId: {
    type: [String, Number],
    default: null
  }
})

// 定义 emits
const emit = defineEmits(['update:modelValue', 'success'])

// store引用
const sysDictDataStore = useSysDictDataStore();
const customerStoreInfoStore = useCustomerStoreInfoStore();
const projectServiceOrderStore = useProjectServiceOrderStore();
const userDataStore = useUserDataStore();

// 响应式数据
const visible = ref(false)
const loading = ref(false)
const formRef = ref()
const subTableEditVisible = ref(false)
// 移除了 workOrderDetailData

// 判断是否为编辑模式
const isEditMode = ref(false)

// 下拉框选项计算属性
// 项目服务单选项
const projectServiceOrderOptions = computed(() => {
  return projectServiceOrderStore.projectServiceOrderData.map(item => ({
    value: item.id,
    label: `${item.id}-${item.serviceContent || ''}`
  }));
});
// 所属门店选项
const customerStoreOptions = computed(() => {
  return customerStoreInfoStore.customerStore.map(item => ({
    value: item.id,
    label: item.storeName
  }));
});
// 工单类型选项
const workOrderTypeOptions = computed(() => {
  return sysDictDataStore.workOrderInfoWorkorderTypeList.map(item => ({
    value: item.dictValue,
    label: item.dictLabel
  }));
});

// 工作类别选项
const workCategoryOptions = computed(() => {
  return sysDictDataStore.workOrderInfoWorkCategoryList.map(item => ({
    value: item.dictValue,
    label: item.dictLabel
  }));
});

// 服务人员选项
const userOptions = computed(() => {
  return userDataStore.userList.map(item => ({
    value: item.id,
    label: item.nickname
  }));
});

// 工单状态选项
const workOrderStatusOptions = computed(() => {
  return sysDictDataStore.workOrderInfoWorkStatusList.map(item => ({
    value: item.dictValue,
    label: item.dictLabel
  }));
});

// 表单数据
const formData = ref({
  id: null,
  projectServiceOrderId: null,
  workorderCode: '',
  workorderType: '',
  workCategory: '',
  storeId: '',
  serviceTime: null,
  startTime: null, // 添加开始时间字段
  endTime: null,   // 添加结束时间字段
  workContent: '',
  workStatus: '',
  urgent: false,
  workLocation: '',
  contactPerson: '',
  contactPhone: '',
  estimatedDuration: null,
  actualDuration: null,
  servicePersonIds: [], // 添加服务人员字段，默认为空数组
  remark: ''
})

// 表单验证规则
const rules = ref({
  projectServiceOrderId: [
    { required: true, message: '请输入项目服务单ID' }
  ],
  storeId: [
    { required: true, message: '请选择门店' }
  ],
  workorderCode: [
    { min: 1, max: 50, message: '工单编码长度为1-50个字符' }
  ],
  workorderType: [
    { required: true, message: '请选择工单类型' }
  ],
  workCategory: [
    { required: true, message: '请选择工作类别' }
  ],
  serviceTime: [
    { required: true, message: '请选择计划时间段' }
  ],
  workContent: [
    // { required: true, message: '请输入工作内容' },
    { max: 1000, message: '工作内容长度不能超过500个字符' }
  ],
  workStatus: [
    { required: true, message: '请选择工单状态' }
  ],
  contactPhone: [
    {
      match: /^1[3-9]\d{9}$/,
      message: '请输入正确的手机号码'
    }
  ],
  servicePersonIds: [
    { required: true, message: '请选择服务人员' }
  ]
})

// 监听 modelValue 变化
watch(() => props.modelValue, (newVal) => {
  visible.value = newVal
  if (newVal) {
    if (props.workOrderId) {
      isEditMode.value = true
      fetchWorkOrderInfo()
    } else {
      isEditMode.value = false
      resetForm()
    }
  }
})

// 监听 visible 变化
watch(visible, (newVal) => {
  emit('update:modelValue', newVal)
})

function handleProjectServiceOrderChange(newVal) {
  // 从store中查找对应的服务单信息
  const serviceOrder = projectServiceOrderStore.projectServiceOrderDataIdMap.get(newVal);
  if (serviceOrder) {

    formData.value.remark = serviceOrder.remark;
    // 处理服务人员ID，将逗号分隔的字符串转为数组
    if (serviceOrder.servicePersonIds) {
      formData.value.servicePersonIds = serviceOrder.servicePersonIds.split(',').map(id => id.trim()).filter(id => id);
    } else {
      formData.value.servicePersonIds = [];
    }
    formData.value.workCategory = serviceOrder.isOvertime ? '1' : '2';
    formData.value.workContent = serviceOrder.serviceContent;
    if (serviceOrder.unitServiceHours) {
      formData.value.estimatedDuration = serviceOrder.unitServiceHours * 60;
    } else {
      formData.value.estimatedDuration = null;
    }
    if (serviceOrder.storeId) {
      formData.value.storeId = serviceOrder.storeId;
    } else {
      formData.value.storeId = '';
    }
    const customerStore = serviceOrder.storeId ? customerStoreInfoStore.customerStoreIdMap.get(newVal) : null;
    if (customerStore) {
      console.log('门店信息', customerStore);
      formData.value.contactPerson = customerStore.contactPerson;
      formData.value.contactPhone = customerStore.contactPhone;
      formData.value.workLocation = customerStore.detailedAddress;
    } else {
      formData.value.contactPerson = null;
      formData.value.contactPhone = null;
      formData.value.workLocation = null;
    }
  } else {
    // 如果清空了服务单，则也清空门店信息
    formData.value.storeId = null;
    formData.value.remark = null;
    formData.value.servicePersonIds = [];
    formData.value.workCategory = null;
    formData.value.workContent = null;
    formData.value.estimatedDuration = null;
    formData.value.contactPerson = null;
    formData.value.contactPhone = null;
    formData.value.workLocation = null;
  }
}
// 组件挂载时确保数据已加载
onMounted(() => {
  // 确保门店数据已加载
  if (customerStoreInfoStore.customerStore.length === 0) {
    customerStoreInfoStore.initCustomerStoreData()
  }

  // 确保用户数据已加载
  if (userDataStore.userList.length === 0) {
    userDataStore.initUserData()
  }
})

// 重置表单
const resetForm = () => {
  formData.value = {
    id: null,
    projectServiceOrderId: null,
    workorderCode: '',
    workorderType: '1',
    workCategory: '2',
    storeId: '',
    serviceTime: null,
    startTime: null, // 添加开始时间字段
    endTime: null,   // 添加结束时间字段
    workContent: '',
    workStatus: '1', // 新增工单时默认工单状态为1
    urgent: false,
    workLocation: '',
    contactPerson: '',
    contactPhone: '',
    estimatedDuration: null,
    actualDuration: null,
    servicePersonIds: [], // 重置服务人员字段
    remark: ''
  }

  nextTick(() => {
    formRef.value?.clearValidate()
  })
}

// 获取工单信息
const fetchWorkOrderInfo = async () => {
  if (!props.workOrderId) return

  loading.value = true
  try {
    const response = await getWorkOrder(props.workOrderId)
    if (response.code === 0) {
      const data = response.data
      // workOrderDetailData.value = data  // 移除了这行
      formData.value = {
        id: data.id,
        projectServiceOrderId: data.projectServiceOrderId || null,
        workorderCode: data.workorderCode || '',
        workorderType: data.workorderType || '',
        workCategory: data.workCategory || '',
        storeId: data.storeId || '',
        serviceTime: data.serviceTime || null,
        startTime: data.startTime ? new Date(data.startTime) : null, // 处理开始时间，将时间戳转换为日期对象
        endTime: data.endTime ? new Date(data.endTime) : null,       // 处理结束时间，将时间戳转换为日期对象
        workContent: data.workContent || '',
        workStatus: data.workStatus || '1', // 编辑工单时如果没有工单状态，默认为1
        urgent: data.urgent || false,
        workLocation: data.workLocation || '',
        contactPerson: data.contactPerson || '',
        contactPhone: data.contactPhone || '',
        estimatedDuration: data.estimatedDuration || null,
        actualDuration: data.actualDuration || null,
        // 处理服务人员ID，将逗号分隔的字符串转为数组
        servicePersonIds: data.servicePersonIds ? data.servicePersonIds.split(',').map(id => id.trim()).filter(id => id) : [],
        remark: data.remark || ''
      }
    } else {
      Message.error(response.message || '获取工单信息失败')
    }
  } catch (error) {
    Message.error('获取工单信息失败')
    console.error('获取工单信息失败:', error)
  } finally {
    loading.value = false
  }
}

// 处理确认按钮
const handleOk = async (done) => {
  try {
    // 验证表单
    const validateResult = await formRef.value?.validate()

    // 如果验证失败，阻止提交和关闭弹框
    if (validateResult !== undefined) {
      done(false)
      return false
    }

    loading.value = true

    // 准备提交数据
    const submitData = { ...formData.value }

    // 处理服务人员ID，将数组转为逗号分隔的字符串
    if (Array.isArray(submitData.servicePersonIds)) {
      submitData.servicePersonIds = submitData.servicePersonIds.join(',');
    }

    // 处理时间字段
    if (submitData.serviceTime) {
      // 如果是日期对象，转换为时间戳
      if (submitData.serviceTime instanceof Date) {
        submitData.serviceTime = submitData.serviceTime.getTime()
      }
      // 如果是字符串格式的日期，转换为时间戳
      else if (typeof submitData.serviceTime === 'string') {
        submitData.serviceTime = new Date(submitData.serviceTime).getTime()
      }
    } else {
      submitData.serviceTime = null
    }

    // 处理开始时间字段
    if (submitData.startTime) {
      // 如果是日期对象，转换为时间戳
      if (submitData.startTime instanceof Date) {
        submitData.startTime = submitData.startTime.getTime()
      }
      // 如果是字符串格式的日期，转换为时间戳
      else if (typeof submitData.startTime === 'string') {
        submitData.startTime = new Date(submitData.startTime).getTime()
      }
    } else {
      submitData.startTime = null
    }

    // 处理结束时间字段
    if (submitData.endTime) {
      // 如果是日期对象，转换为时间戳
      if (submitData.endTime instanceof Date) {
        submitData.endTime = submitData.endTime.getTime()
      }
      // 如果是字符串格式的日期，转换为时间戳
      else if (typeof submitData.endTime === 'string') {
        submitData.endTime = new Date(submitData.endTime).getTime()
      }
    } else {
      submitData.endTime = null
    }

    let response

    if (isEditMode.value) {
      response = await updateWorkOrder(submitData)
    } else {
      delete submitData.id // 新增时删除id字段
      response = await addWorkOrder(submitData)
    }

    if (response.code === 0) {
      Message.success(isEditMode.value ? '修改项目工单成功' : '新增项目工单成功')
      emit('success')
      visible.value = false
      done(true)
      return true
    } else {
      Message.error(response.message || `${isEditMode.value ? '修改' : '新增'}项目工单失败`)
      done(false)
    }
  } catch (error) {
    // 如果是表单验证错误，不显示网络错误提示
    if (error && typeof error === 'object' && error.name !== 'ValidateError') {
      Message.error(`${isEditMode.value ? '修改' : '新增'}项目工单失败`)
      console.error('操作失败:', error)
    }
    done(false)
    return false
  } finally {
    loading.value = false
  }
}

// 处理取消按钮
const handleCancel = () => {
  formRef.value?.clearValidate()
  visible.value = false
}

// 打开子表编辑
const openSubTableEdit = () => {
  subTableEditVisible.value = true
  // 关闭主编辑模态框
  visible.value = false
}

// 处理子表编辑成功
const handleSubTableSuccess = (data) => {
  console.log('子表编辑成功:', data)
  // 可以在这里更新主表数据或刷新页面
  Message.success('子表信息保存成功')
  // 重新打开主编辑模态框
  // visible.value = true
}
</script>

<style scoped>
.a-form-item {
  margin-bottom: 16px;
}
</style>